// extracted by mini-css-extract-plugin
module.exports = {"tilesContainer":"StrategiesTilesView_tilesContainer__1OaiH"};